import React from 'react';
interface GeometricAccentProps {
  className?: string;
  variant?: 'star' | 'octagon' | 'dots' | 'arabesque';
  color?: string;
  opacity?: number;
}
// Decorative geometric accent removed sitewide — component intentionally renders
// nothing so existing usages and props remain valid without showing the pattern.
export function GeometricAccent(_props: GeometricAccentProps) {
  return null;
}
function GeometricAccentArchived({
  className = '',
  variant = 'star',
  color = '#C9A864',
  opacity = 0.12
}: GeometricAccentProps) {
  if (variant === 'dots') {
    return <svg viewBox="0 0 120 120" className={className} aria-hidden="true" style={{
      opacity
    }} data-id="element-753" data-mp="196frr3zws43">
        {Array.from({
        length: 8
      }).map((_, i) => Array.from({
        length: 8
      }).map((_, j) => <circle key={`${i}-${j}`} cx={8 + i * 14} cy={8 + j * 14} r="1.4" fill={color} data-id="element-754" data-mp="2zz6kp4y6pogw" data-mpi={j} />))}
      </svg>;
  }
  if (variant === 'octagon') {
    return <svg viewBox="0 0 200 200" className={className} aria-hidden="true" style={{
      opacity
    }} data-id="element-755" data-mp="e9y2kjjroat3">
        <g fill="none" stroke={color} strokeWidth="1" data-id="element-756" data-mp="n4cecc53937g">
          {[40, 60, 80, 100].map(r => <polygon key={r} points={Array.from({
          length: 8
        }).map((_, i) => {
          const a = i * Math.PI / 4;
          return `${100 + Math.cos(a) * r},${100 + Math.sin(a) * r}`;
        }).join(' ')} data-id="element-757" data-mp="3mjhg1u27caak" />)}
        </g>
      </svg>;
  }
  if (variant === 'arabesque') {
    return <svg viewBox="0 0 200 200" className={className} aria-hidden="true" style={{
      opacity
    }} data-id="element-758" data-mp="1asluoyjj8yr7">
        <g fill="none" stroke={color} strokeWidth="1" data-id="element-759" data-mp="3bvmpcb7in2fq">
          <circle cx="100" cy="100" r="60" data-id="element-760" data-mp="3bu1x4s8obvl1" />
          <circle cx="100" cy="40" r="30" data-id="element-761" data-mp="37ub9uyicvxl9" />
          <circle cx="100" cy="160" r="30" data-id="element-762" data-mp="37t9mpvo2fkn6" />
          <circle cx="40" cy="100" r="30" data-id="element-763" data-mp="3ltsqurpeu6k2" />
          <circle cx="160" cy="100" r="30" data-id="element-764" data-mp="3lsrg6ocb3m2v" />
          <circle cx="58" cy="58" r="20" data-id="element-765" data-mp="3lrgcspmrwgca" />
          <circle cx="142" cy="58" r="20" data-id="element-766" data-mp="3gug6cdm0hbkn" />
          <circle cx="58" cy="142" r="20" data-id="element-767" data-mp="3gsmxcrnxef9h" />
          <circle cx="142" cy="142" r="20" data-id="element-768" data-mp="2t4lunzdfht1z" />
        </g>
      </svg>;
  }
  // 8-point star (default)
  return <svg viewBox="0 0 200 200" className={className} aria-hidden="true" style={{
    opacity
  }} data-id="element-769" data-mp="2o73im0446xpr">
      <g fill="none" stroke={color} strokeWidth="1.2" data-id="element-770" data-mp="32x1buugwidlt">
        <polygon points={Array.from({
        length: 8
      }).map((_, i) => {
        const a = i * Math.PI / 4;
        return `${100 + Math.cos(a) * 80},${100 + Math.sin(a) * 80}`;
      }).join(' ')} data-id="element-771" data-mp="2y3ycu6tcuby8" />
        <polygon points={Array.from({
        length: 8
      }).map((_, i) => {
        const a = i * Math.PI / 4 + Math.PI / 8;
        return `${100 + Math.cos(a) * 80},${100 + Math.sin(a) * 80}`;
      }).join(' ')} data-id="element-772" data-mp="kxs21nx5dk6m" />
        <circle cx="100" cy="100" r="40" data-id="element-773" data-mp="fy5qdiwywbzx" />
      </g>
    </svg>;
}